<article class="cej-form-result-card">
  <button
    mat-icon-button
    type="button"
    aria-label="Fermer la carte de résultat"
    class="btn-clean btn-close cej-form-result-card__cross-btn"
    (click)="close()"
  >
    <mat-icon svgIcon="cross" role="presentation"></mat-icon>
  </button>
  <h2 class="cej-form-result-card__title">{{ cardConfig.title }}</h2>
  <p class="cej-form-result-card__content-text" *ngIf="cardConfig?.textContent">{{ cardConfig.textContent }}</p>
  <a
    *ngIf="cardConfig?.button.type === CejCardResultLinkType.HREF; else linkRouterTmpl"
    class="btn-clean btn cej-form-result-card__btn"
    [href]="cardConfig.button.link"
    [attr.aria-label]="cardConfig.button.ariaLabel"
    (click)="trackerEvent()"
    >{{ cardConfig.button.text }}
  </a>
  <button class="cej-form-result-card__close-btn btn-clean" (click)="close()">Fermer</button>
  <ng-template #linkRouterTmpl>
    <a
      class="btn-clean btn cej-form-result-card__btn"
      [routerLink]="cardConfig.button.link"
      [attr.aria-label]="cardConfig.button.ariaLabel"
      (click)="trackerEvent()"
      >{{ cardConfig.button.text }}
    </a>
  </ng-template>
</article>
